var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPredictions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.3333 13.0098H9.33329M11.6666 17.6764H9.33329M18.6666 8.3431H9.33329M23.3333 12.4264V8.10977C23.3333 6.14958 23.3333 5.16949 22.9518 4.4208C22.6163 3.76223 22.0808 3.2268 21.4223 2.89124C20.6736 2.50977 19.6935 2.50977 17.7333 2.50977H10.2666C8.30644 2.50977 7.32635 2.50977 6.57766 2.89124C5.91909 3.2268 5.38366 3.76223 5.0481 4.4208C4.66663 5.16949 4.66663 6.14958 4.66663 8.10977V20.2431C4.66663 22.2033 4.66663 23.1834 5.0481 23.9321C5.38366 24.5906 5.91909 25.1261 6.57766 25.4616C7.32635 25.8431 8.30644 25.8431 10.2666 25.8431H13.4166M25.6666 25.8431L23.9166 24.0931M25.0833 21.1764C25.0833 23.4316 23.2551 25.2598 21 25.2598C18.7448 25.2598 16.9166 23.4316 16.9166 21.1764C16.9166 18.9213 18.7448 17.0931 21 17.0931C23.2551 17.0931 25.0833 18.9213 25.0833 21.1764Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPredictions);
export default __webpack_public_path__ + "static/media/predictions.7f312405e2b596caa594e919334235c6.svg";
export { ForwardRef as ReactComponent };